// extracted by mini-css-extract-plugin
export default {"container":"GoldMemberAd_container__0gZhP","title":"GoldMemberAd_title__wCgzf","text":"GoldMemberAd_text__t-eZE","button":"GoldMemberAd_button__gTrZm"};